import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import blockUI from 'react-block-ui/reduxMiddleware';
import api from './common/middleware/api';
import analytics from './common/middleware/analytics';
import rootReducer from './reducers';
import Config from 'Config';

const middlewares = [
	thunk,
	api,
	analytics,
	blockUI
];

if (Config.environment !== 'production') {
	const { logger } = require('redux-logger');

	middlewares.push(logger);
}

const composeEnhancers = (Config.environment !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const configureStore = preloadedState =>
	createStore(
		rootReducer,
		preloadedState,
		composeEnhancers(applyMiddleware(...middlewares))
	);

export default configureStore;